declare var window: Window;
declare var document: Document;

import { useState, useEffect } from 'react';

export default function useShowFixedHeader(scrollPoint: number) {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const showFixedHeader = window.scrollY > scrollPoint;

      if (showFixedHeader !== show) {
        setShow(showFixedHeader);
      }
    };

    document.addEventListener('scroll', onScroll);

    return () => {
      document.removeEventListener('scroll', onScroll);
    };
  }, [show, setShow, scrollPoint]);

  return show;
}
